import styled from "styled-components";
import Card from "@material-ui/core/Card";

const WhatHotGridWrapper = styled(Card)`
  width: calc((100% / 3) - 32px);
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: none;
  border-bottom: 5px solid ${(props) => props.theme.colors.secondary.main}
  cursor: pointer;
  &:hover {
    background: #F5F5F5;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 4px 0px;
  }
  .whats-hot-details {
    height: 80px;
    color: black;
  }
  .collection-title {
    color: black;
    font-size: 21px;
    line-height: 27px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    white-space: nowrap;
    display: block;
  }
  .collection-sub {
    padding-bottom: 24px;
    font-size: 14px;
    color: black;
    height: 47px;
    white-space: nowrap;
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .collection-image{
    height: 228px;
  }
  
  .MuiCardContent-root {
    width: 100%;
    position: relative;

    .collection-list-share-btn {
      position: absolute;
      top: -13px;
      right: -5px;
      &:hover {
        border-radius: 50% !important;
      }
      svg {
        height: 24px;
        width: 24px
      }
    }
  }
  .whats-hot-card-container {
    position: relative; 
    .hotCollection__description{
      display: block;
      position: relative;
      .hot-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        word-wrap: break-word;
        word-break: keep-all;
        width: 88%;
        font-size: 14px;
      }
    }
  }
`;

export default WhatHotGridWrapper;
